import SHWEBCommentChild from './src/child.vue';
/**
 * web端评论组件
 */

/* istanbul ignore next */
SHWEBCommentChild.install = function(Vue) {
    Vue.component('sh-web-comment-child', SHWEBCommentChild);
  };
  export default SHWEBCommentChild;




// WEBPACK FOOTER //
// ./src/components/base/view/interact/cmps/comment/web/child/index.js